import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center relative overflow-hidden px-6" data-testid="admin-login-page">
      <div className="spotlight absolute inset-0" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md bg-white border border-zinc-200 p-10 md:p-14"
      >
        <Link to="/" data-testid="admin-login-logo">
          <Logo size="md" />
        </Link>
        <p className="text-[10px] uppercase tracking-[0.4em] text-gold mt-8 mb-2">Private Entrance</p>
        <h1 className="font-serif font-medium text-4xl text-zinc-900">The Back Office</h1>
        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <label className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 block mb-2.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-zinc-100 border border-zinc-200 text-zinc-900 text-sm px-4 py-3.5 focus:outline-none focus:border-gold/60 transition-colors duration-300"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 block mb-2.5">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-zinc-100 border border-zinc-200 text-zinc-900 text-sm px-4 py-3.5 focus:outline-none focus:border-gold/60 transition-colors duration-300"
            />
          </div>
          {error && (
            <p className="text-red-400 text-xs tracking-wide" data-testid="admin-login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-gold text-white text-xs uppercase tracking-[0.3em] py-4 hover:bg-champagne transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Entering…" : "Enter the Maison"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
